import axios from "./configApi";

export const getAboutPage = async () => {
  try {
    const res = await axios.get(`/static-pages/ABOUT`);
    return res.data;
  } catch (error) {
    // return error.response.data;
    return Promise.reject(error);
  }
};

export const getTermsPage = async () => {
  try {
    const res = await axios.get(`/static-pages/TERMS`);
    return res.data;
  } catch (error) {
    // return error.response.data;
    return Promise.reject(error);
  }
};

export const getPrivacyPage = async () => {
  try {
    const res = await axios.get(`/static-pages/PRIVACY`);
    return res.data;
  } catch (error) {
    // return error.response.data;
    return Promise.reject(error);
  }
};

export const getFAQPage = async () => {
  try {
    const res = await axios.get(`/static-pages/FAQ`);
    return res.data;
  } catch (error) {
    // return error.response.data;
    return Promise.reject(error);
  }
};

export interface AppVersioning {
  min_version: string | number;
  force_update: boolean;
  ios_link: string;
  android_link: string;
}

export const getVersioningPage = async (): Promise<AppVersioning> => {
  try {
    const res = await axios.get(`/static-pages/VERSIONING`);
    const data = res.data;
    const raw = data?.content ?? data;

    if (typeof raw === "string") {
      return JSON.parse(raw) as AppVersioning;
    }

    return raw as AppVersioning;
  } catch (error) {
    return Promise.reject(error);
  }
};

const VERSIONING_PAGE_NAME = "Versioning";

export const updateVersioningPage = async (
  versioning: AppVersioning
): Promise<unknown> => {
  const params = new URLSearchParams();
  params.append("name", VERSIONING_PAGE_NAME);
  params.append("content", JSON.stringify(versioning));

  const res = await axios.put(`/static-pages/VERSIONING`, params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return res.data;
};
